import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import { useConfigStore } from "@/store/config";
import { useRBCSlideStore } from "@/store/modules/RBCregion";
import type { CellGroupsPostPayload, RBCBackendPayload } from "@/types/api";
import { useApi, useConstants, useCookie } from "@/composables/useAppGlobals";

export function useRBC() {
  const $api = useApi();
  const $const = useConstants();
  const $cookie = useCookie();

  const isBusy = ref(false);
  const isReviewed = ref(false);

  const configStore = useConfigStore();
  const slideStore = useRBCSlideStore();

  const { slideInfo } = storeToRefs(configStore);

  const cellBackendRequestObj = computed<RBCBackendPayload>(() => ({
    cells: slideStore.serializeSchema(),
  }));

  async function postCells(payload: CellGroupsPostPayload) {
    try {
      const resp = await $api.postCells(
        slideInfo.value[$const.SLIDE_KEYS.SLIDE_ID] as string,
        payload,
      );
      configStore.updateSlideInfoKey(
        $const.SLIDE_KEYS.REVIEW_TIME,
        resp.data[$const.SLIDE_KEYS.REVIEW_TIME]
      );
      configStore.updateSlideInfoKey(
        $const.SLIDE_KEYS.REVIEWER,
        $cookie.getCookie($const.COOKIES.KEY.USER_NAME)
      );
      isReviewed.value = true;
    } finally {
      isBusy.value = false;
    }
  }

  async function save() {
    isBusy.value = true;
    const payload: CellGroupsPostPayload = {
      ...cellBackendRequestObj.value,
      state: (slideInfo.value[$const.SLIDE_KEYS.STATE] as string) || "",
    };
    await postCells(payload);
  }

  function resetState() {
    slideStore.reset();
    configStore.resetState();
  }

  return {
    isBusy,
    isReviewed,
    slideInfo,
    cellBackendRequestObj,
    postCells,
    save,
    resetState,
  };
}

export default useRBC;
